(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // The cart drawer: product forms add to the cart without leaving the
  // page, then the drawer slides in. Quantity buttons and Remove update it
  // in place. Everything re-renders from Shopify (Section Rendering API),
  // so the drawer's Liquid stays the one source of truth.
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.root = this.dataset.root || '/';
      this.sectionId = this.closest('.shopify-section')?.id.replace('shopify-section-', '') || 'cart-drawer';

      // Capture phase: runs before any app's own listener on the form, so
      // an add goes through the drawer once and only once.
      this.onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this.onSubmit, true);

      document.querySelectorAll('[data-cart-open]').forEach((link) =>
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        })
      );

      this.addEventListener('click', (event) => {
        const target = event.target;
        if (target === this.dialog || target.closest('[data-cart-close]')) return this.close();
        const copy = target.closest('[data-cart-copy-code]');
        if (copy) return this.copyCode(copy.dataset.code, copy);
        const go = target.closest('[data-cart-checkout]');
        if (go) {
          // Hand the code to Shiprocket, and to the clipboard as a backstop in
          // case it does not take. The tap is the gesture the clipboard needs.
          if (go.dataset.code) {
            this.prefillCode(go.dataset.code);
            this.copyCode(go.dataset.code);
          }
          return this.checkout();
        }
        const change = target.closest('[data-line][data-quantity]');
        if (change) this.change(Number(change.dataset.line), Number(change.dataset.quantity));
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
    }

    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add\/?$/.test(new URL(form.action, location.href).pathname)) return;
      event.preventDefault();
      event.stopPropagation();
      this.add(form, event.submitter);
    }

    async add(form, button) {
      button?.setAttribute('aria-busy', 'true');
      const body = new FormData(form);
      body.append('sections', this.sectionId);
      body.append('sections_url', location.pathname);
      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        if (!response.ok) throw new Error(String(response.status));
        const data = await response.json();
        this.render(data.sections?.[this.sectionId]);
        this.open();
      } catch (error) {
        // Let the browser do a normal submit: Shopify shows its own message.
        form.submit();
      } finally {
        button?.removeAttribute('aria-busy');
      }
    }

    async change(line, quantity) {
      this.dialog.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: [this.sectionId], sections_url: location.pathname }),
        });
        const data = await response.json();
        this.render(data.sections?.[this.sectionId]);
      } finally {
        this.dialog.removeAttribute('aria-busy');
      }
    }

    render(html) {
      if (!html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
      const current = this.querySelector('[data-cart-drawer-content]');
      if (!fresh || !current) return;
      current.replaceWith(fresh);
      this.updateCount(Number(fresh.dataset.count));
    }

    // The yellow bubble on the header's cart icon.
    updateCount(count) {
      document.querySelectorAll('[data-cart-open]').forEach((link) => {
        let bubble = link.querySelector('.header__cart-count');
        if (count > 0) {
          if (!bubble) {
            bubble = document.createElement('span');
            bubble.className = 'header__cart-count';
            bubble.setAttribute('aria-hidden', 'true');
            link.append(bubble);
          }
          bubble.textContent = count > 99 ? '99+' : String(count);
        } else {
          bubble?.remove();
        }
      });
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.removeAttribute('data-closing');
      this.dialog.showModal();
      // Focus the title, so screen readers start there and no focus ring
      // lands on the close button.
      this.querySelector('#CartDrawerTitle')?.focus();
    }

    close() {
      if (!this.dialog.open) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return this.dialog.close();
      this.dialog.setAttribute('data-closing', '');
      this.dialog.addEventListener(
        'animationend',
        () => {
          this.dialog.removeAttribute('data-closing');
          this.dialog.close();
        },
        { once: true }
      );
    }

    // Copies the code and says so. Clipboard access can be refused (older
    // browsers, no permission), so it falls back to a hidden input, and the
    // code stays on screen either way.
    async copyCode(code, button) {
      if (!code) return;
      let done = false;
      try {
        await navigator.clipboard.writeText(code);
        done = true;
      } catch {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;top:-100px;opacity:0';
        this.dialog.appendChild(field);
        field.select();
        try {
          done = document.execCommand('copy');
        } catch {
          done = false;
        }
        field.remove();
      }

      if (button) {
        button.toggleAttribute('data-copied', done);
        clearTimeout(this.copiedTimer);
        this.copiedTimer = setTimeout(() => button.removeAttribute('data-copied'), 2000);
      }

      const toast = this.querySelector('[data-cart-toast]');
      if (!toast) return;
      const template = done ? toast.dataset.copied : toast.dataset.failed;
      toast.textContent = (template || '').replace('%CODE%', code);
      toast.hidden = false;
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        toast.hidden = true;
      }, 5000);
    }

    // Shiprocket's checkout when its script has loaded, else Shopify's.
    // The drawer is a modal dialog, which sits above everything else on the
    // page, so it closes first or Shiprocket's pop-up would open behind it.
    // Shiprocket reads Shopify's own `discount_code` cookie and carries it into
    // its checkout, so setting that saves the buyer pasting anything. The
    // /discount/ call also applies it on Shopify's side, for the fallback.
    prefillCode(code) {
      if (!code) return;
      document.cookie = `discount_code=${encodeURIComponent(code)}; path=/; max-age=1800; samesite=lax`;
      fetch(`${this.root}discount/${encodeURIComponent(code)}`).catch(() => {});
    }

    checkout() {
      if (typeof window.shiprocketCheckoutBuyCartHandler === 'function') {
        this.dialog.removeAttribute('data-closing');
        this.dialog.close();
        window.shiprocketCheckoutBuyCartHandler();
      } else {
        window.location.href = `${this.root}checkout`;
      }
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-menu-open]');

      this.openButton.addEventListener('click', () => this.open());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-menu-close]')) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.openButton.setAttribute('aria-expanded', 'false'));
    }

    open() {
      this.dialog.showModal();
      this.openButton.setAttribute('aria-expanded', 'true');
    }
  }

  if (!customElements.get('menu-drawer')) customElements.define('menu-drawer', MenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holistic-gummy"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-hg]');
    if (!root) return;
    const data = JSON.parse(root.querySelector('[data-hg-data]').textContent);
    const $ = (sel, el = root) => el.querySelector(sel);
    const $$ = (sel, el = root) => [...el.querySelectorAll(sel)];
    const inr = (n) => '₹' + Math.round(n).toLocaleString('en-IN');
    const FREQ_LABEL = { monthly: 'Every month', fortnightly: 'Once in 15 days', weekly: 'Every week' };
    const FREQ_MATCH = { monthly: /month|30/i, fortnightly: /15|fortnight|two week|2 week/i, weekly: /week|7/i };

    // Pack / mode / quantity / frequency are shared by the buy box and the sticky bar.
    const state = { pack: data.defaultPack, mode: 'subscribe', tier: 0, freq: 'monthly' };

    // Subscribing goes through a selling plan when a subscription app has added
    // one; otherwise through the Subscribe variant.
    function sellingPlan(pack) {
      const plans = pack.oneTime?.plans || [];
      if (!plans.length) return null;
      return plans.find((p) => FREQ_MATCH[state.freq].test(p.name)) || plans[0];
    }

    function pricing() {
      const pack = data.packs[state.pack];
      const isTrial = !pack.sub && !(pack.oneTime?.plans || []).length;
      const subscribing = state.mode === 'subscribe' && !isTrial;
      const tier = isTrial ? data.tiers[0] : data.tiers[state.tier];
      const qty = tier.qty;
      const oneTimeUnit = pack.oneTime ? pack.oneTime.price : pack.sub.price;
      const plan = subscribing ? sellingPlan(pack) : null;
      const subUnit = plan ? plan.price : pack.sub ? pack.sub.price : oneTimeUnit;
      const modeUnit = subscribing ? subUnit : oneTimeUnit;
      const total = (q, pct) => Math.round(modeUnit * q * (1 - pct / 100));
      const lineTotal = total(qty, tier.pct);
      return { pack, isTrial, subscribing, qty, tier, oneTimeUnit, subUnit, modeUnit, plan, total, lineTotal };
    }

    // ── Render ──
    const tiersEl = $('[data-hg-tiers]');
    const summaryEl = $('[data-hg-summary]');

    function render() {
      const p = pricing();
      const { pack, isTrial, subscribing, qty, oneTimeUnit, subUnit, modeUnit, lineTotal } = p;

      $$('[data-hg-pack]', document).forEach((b) => {
        const on = Number(b.dataset.hgPack) === state.pack;
        b.classList.toggle('is-active', on);
        if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', String(on));
      });

      $('[data-hg-mode]').hidden = isTrial;
      $('[data-hg-mode]').textContent = subscribing ? 'Subscription (Bliss Club)' : 'One-time purchase';

      tiersEl.hidden = isTrial;
      tiersEl.innerHTML = isTrial ? '' : data.tiers.map((t, i) => {
        const tTotal = p.total(t.qty, t.pct);
        const per = Math.round(tTotal / (pack.units * t.qty));
        const on = i === state.tier;
        return `<button type="button" class="hg-tier${on ? ' is-active' : ''}" role="radio" aria-checked="${on}" data-hg-tier="${i}">
          ${t.badge ? `<span class="hg-tier__badge">${t.badge}</span>` : ''}
          <span class="hg-tier__row">
            <span class="hg-tier__left"><span class="hg-radio"></span><span class="hg-tier__name">${t.qty} Pack</span>
              ${t.pct > 0 ? `<span class="hg-tier__save">SAVE ${t.pct}%</span>` : ''}</span>
            <span class="hg-tier__price"><strong>${inr(tTotal)}</strong>${t.qty > 1 ? `<s>${inr(oneTimeUnit * t.qty)}</s>` : ''}</span>
          </span>
          <span class="hg-tier__per">${inr(per)} / gummy</span>
        </button>`;
      }).join('');

      $('[data-hg-perks]').hidden = !subscribing;
      $('[data-hg-freq]').hidden = !subscribing;
      $('[data-hg-sub-note]').hidden = !subscribing;
      $('[data-hg-trial-note]').hidden = !isTrial;

      const listTotal = oneTimeUnit * qty;
      const subSaving = subscribing ? (oneTimeUnit - subUnit) * qty : 0;
      const qtySaving = Math.round(modeUnit * qty) - lineTotal;
      const youSave = listTotal - lineTotal;
      summaryEl.innerHTML = `
        <div class="hg-summary__row hg-summary__row--list"><span>List price${qty > 1 ? ` (${qty} ×)` : ''}</span><s>${inr(listTotal)}</s></div>
        ${subSaving > 0 ? `<div class="hg-summary__row"><span>Subscriber saving</span><span>−${inr(subSaving)}</span></div>` : ''}
        ${qtySaving > 0 ? `<div class="hg-summary__row"><span>Quantity saving</span><span>−${inr(qtySaving)}</span></div>` : ''}
        <div class="hg-summary__total"><span>You pay</span><span>${inr(lineTotal)}</span></div>
        ${youSave > 0 ? `<p class="hg-summary__save">You save ${inr(youSave)}</p>` : ''}`;

      $('[data-hg-cta-price]').textContent = inr(lineTotal);

      const sw = $('[data-hg-switch]');
      sw.hidden = isTrial;
      sw.textContent = subscribing ? 'Prefer to buy once? →' : `Subscribe & save ${inr((oneTimeUnit - (sellingPlan(pack)?.price ?? pack.sub?.price ?? oneTimeUnit)) * qty)} →`;

      // The cart line.
      const usePlan = subscribing && p.plan;
      const variant = subscribing && !usePlan ? pack.sub : pack.oneTime || pack.sub;
      $('[data-hg-id]').value = variant.id;
      $('[data-hg-qty]').value = qty;
      const planInput = $('[data-hg-plan]');
      planInput.disabled = !usePlan;
      planInput.value = usePlan ? p.plan.id : '';
      const delivery = $('[data-hg-prop-delivery]');
      delivery.disabled = !subscribing;
      delivery.value = FREQ_LABEL[state.freq];
      $('[data-hg-prop-sub]').disabled = !subscribing;
      const soldOut = variant.available === false;
      $('[data-hg-add]').disabled = soldOut;
      $('[data-hg-buynow]').disabled = soldOut;

      // Sticky bar.
      const modeLabel = (subscribing ? 'Subscribe' : 'One-time') + (qty > 1 ? ` · ${qty} Pack` : '');
      $('[data-hg-sticky-mode]').textContent = modeLabel;
      $('[data-hg-sticky-price-mode]').textContent = modeLabel;
      $('[data-hg-sticky-pack]').textContent = pack.label;
      $('[data-hg-sticky-price]').textContent = inr(lineTotal);
    }

    // ── Gallery ──
    const main = $('[data-hg-main]');
    const thumbs = () => $$('[data-hg-thumb]');
    let current = 0;
    function showImage(i) {
      const list = thumbs();
      current = Math.max(0, Math.min(i, list.length - 1));
      const t = list[current];
      main.src = t.dataset.src;
      main.srcset = `${t.dataset.src} 800w, ${t.dataset.full} 1400w`;
      main.alt = t.dataset.alt;
      list.forEach((el, n) => el.classList.toggle('is-active', n === current));
      $('[data-hg-count]').textContent = `${current + 1} / ${list.length}`;
      $$('[data-hg-prev]').forEach((b) => (b.hidden = current === 0));
      $$('[data-hg-next]').forEach((b) => (b.hidden = current === list.length - 1));
      const zoomImg = $('[data-hg-zoom-img]');
      zoomImg.src = t.dataset.full;
      zoomImg.alt = t.dataset.alt;
    }
    function setPackImage() {
      const pack = data.packs[state.pack];
      const t = $('[data-pack-thumb]');
      t.dataset.src = pack.image;
      t.dataset.full = pack.imageFull;
      t.dataset.alt = pack.alt;
      t.querySelector('img').src = pack.thumb;
      showImage(0);
    }
    thumbs().forEach((t, i) => t.addEventListener('click', () => showImage(i)));
    $$('[data-hg-prev]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); showImage(current - 1); }));
    $$('[data-hg-next]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); showImage(current + 1); }));

    const zoom = $('[data-hg-zoom]');
    main.addEventListener('click', () => zoom.showModal());
    zoom.addEventListener('click', (e) => { if (e.target === zoom || e.target.closest('[data-hg-zoom-close]')) zoom.close(); });

    function swipe(el) {
      let x0 = null;
      el.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
      el.addEventListener('touchend', (e) => {
        if (x0 == null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) showImage(current + (dx < 0 ? 1 : -1));
      });
    }
    swipe($('[data-hg-stage]'));
    swipe(zoom);

    // ── Buy box events ──
    $$('[data-hg-pack]', document).forEach((b) =>
      b.addEventListener('click', () => {
        state.pack = Number(b.dataset.hgPack);
        const pack = data.packs[state.pack];
        if (!pack.sub && !(pack.oneTime?.plans || []).length) state.mode = 'onetime';
        else if (!pack.oneTime) state.mode = 'subscribe';
        render();
        setPackImage();
      })
    );
    tiersEl.addEventListener('click', (e) => {
      const b = e.target.closest('[data-hg-tier]');
      if (!b) return;
      state.tier = Number(b.dataset.hgTier);
      render();
    });
    $('[data-hg-freq-select]').addEventListener('change', (e) => { state.freq = e.target.value; render(); });
    $('[data-hg-switch]').addEventListener('click', () => {
      state.mode = state.mode === 'subscribe' ? 'onetime' : 'subscribe';
      render();
    });

    const moreBtn = $('[data-hg-more]');
    moreBtn.addEventListener('click', () => {
      const open = moreBtn.getAttribute('aria-expanded') !== 'true';
      moreBtn.setAttribute('aria-expanded', String(open));
      $('[data-hg-more-text]').hidden = !open;
      moreBtn.textContent = open ? 'show less' : 'learn more';
    });

    // Add to Cart submits the form: the cart drawer catches it and slides in.
    // Buy Now adds the same line, then goes straight to checkout.
    const form = $('[data-hg-form]');
    const errorEl = $('[data-hg-error]');

    // Prescription: free consultation (default) or upload an existing one.
    const rxFile = $('[data-hg-rx-file]');
    const rxUpload = $('[data-hg-rx-upload]');
    const syncRx = () => {
      const uploading = form.querySelector('[data-hg-rx-mode]:checked')?.dataset.hgRxMode === 'upload';
      rxUpload.hidden = !uploading;
      rxFile.disabled = !uploading;
      rxFile.required = uploading;
    };
    form.querySelectorAll('[data-hg-rx-mode]').forEach((r) => r.addEventListener('change', syncRx));
    rxFile.addEventListener('change', () => {
      const f = rxFile.files[0];
      rxFile.setCustomValidity(f && f.size > 10 * 1024 * 1024 ? 'Please upload a file under 10 MB.' : '');
    });
    rxFile.addEventListener('invalid', () => {
      if (rxFile.validity.valueMissing) rxFile.setCustomValidity('Please upload your prescription, or choose the free doctor consultation.');
    });
    syncRx();
    $('[data-hg-buynow]').addEventListener('click', async (e) => {
      const btn = e.currentTarget;
      if (!form.reportValidity()) return;
      btn.setAttribute('aria-busy', 'true');
      errorEl.hidden = true;
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || 'Could not add to cart');
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.checkout === 'function') drawer.checkout();
        else window.location.href = '/checkout';
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });

    // ── Sticky bar: shown once the buy-box buttons scroll above the viewport ──
    const sticky = $('[data-hg-sticky]');
    const cta = document.getElementById('hg-buy-cta');
    let frame = 0;
    const checkSticky = () => {
      frame = 0;
      const show = cta.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(checkSticky); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    checkSticky();
    $('[data-hg-sticky-add]').addEventListener('click', () => form.requestSubmit($('[data-hg-add]')));
    $('[data-hg-sticky-jump]').addEventListener('click', () =>
      document.getElementById('ritual').scrollIntoView({ behavior: 'smooth', block: 'start' })
    );

    // ── I want to feel… slider ──
    const slides = $$('[data-hg-feel-slide]');
    const copies = $$('[data-hg-feel-copy]');
    const dots = $$('[data-hg-feel-dot]');
    let active = 0;
    let timer;
    const showSlide = (i) => {
      active = i;
      [slides, copies, dots].forEach((set) => set.forEach((el, n) => el.classList.toggle('is-active', n === i)));
      copies.forEach((el, n) => el.setAttribute('aria-hidden', String(n !== i)));
      dots.forEach((el, n) => el.setAttribute('aria-current', String(n === i)));
    };
    const startTimer = () => {
      clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches)
        timer = setInterval(() => showSlide((active + 1) % slides.length), 5000);
    };
    dots.forEach((d, i) => d.addEventListener('click', () => { showSlide(i); startTimer(); }));
    // Start cycling once the band is near the viewport.
    new IntersectionObserver((entries, io) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      startTimer();
    }, { rootMargin: '200px' }).observe($('[data-hg-feel]'));

    // ── Botanicals + reviews: show more ──
    const seeAll = $('[data-hg-see-all]');
    seeAll.addEventListener('click', () => {
      const open = $('[data-hg-inside]').classList.toggle('is-expanded');
      seeAll.setAttribute('aria-expanded', String(open));
      seeAll.querySelector('[data-label-more]').hidden = open;
      seeAll.querySelector('[data-label-less]').hidden = !open;
    });
    $('[data-hg-more-reviews]').addEventListener('click', () => $('[data-hg-reviews]').classList.add('is-expanded'));

    render();
    setPackImage();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-gallery-rail]');
      this.thumbRow = this.querySelector('[data-gallery-thumbs]');
      this.thumbs = [...this.querySelectorAll('[data-gallery-go]')];
      if (!this.rail || this.thumbs.length === 0) return;

      const slides = [...this.rail.children];
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(Number(thumb.dataset.galleryGo))));

      // The slide that is mostly in view is the current one.
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.mark(slides.indexOf(entry.target));
          });
        },
        { root: this.rail, threshold: 0.6 }
      );
      slides.forEach((slide) => this.observer.observe(slide));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    get smooth() {
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    go(index) {
      const slide = this.rail.children[index];
      if (!slide) return;
      this.rail.scrollTo({ left: slide.offsetLeft, behavior: this.smooth ? 'smooth' : 'auto' });
    }

    mark(index) {
      this.thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });

      // Keep the current thumbnail in view when there are more than fit.
      const thumb = this.thumbs[index];
      if (!thumb || !this.thumbRow) return;
      const left = thumb.offsetLeft - (this.thumbRow.clientWidth - thumb.clientWidth) / 2;
      this.thumbRow.scrollTo({ left, behavior: this.smooth ? 'smooth' : 'auto' });
    }
  }

  // Shows the bar while the page's main Add to cart button is scrolled
  // past (above the screen). Hides it again near the top, and while the
  // last Add to cart on the page is on screen.
  class StickyBuy extends HTMLElement {
    connectedCallback() {
      const main = this.closest('.product')?.querySelector('[data-main-add]');
      if (!main) return;

      this.mainGone = false;
      this.lastSeen = false;
      this.mainObserver = new IntersectionObserver(([entry]) => {
        this.mainGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.sync();
      });
      this.mainObserver.observe(main);

      const last = document.querySelector('[data-last-add]');
      if (last) {
        this.lastObserver = new IntersectionObserver(([entry]) => {
          this.lastSeen = entry.isIntersecting;
          this.sync();
        });
        this.lastObserver.observe(last);
      }
    }

    disconnectedCallback() {
      this.mainObserver?.disconnect();
      this.lastObserver?.disconnect();
    }

    sync() {
      const show = this.mainGone && !this.lastSeen;
      this.toggleAttribute('data-visible', show);
      this.setAttribute('aria-hidden', String(!show));
      this.querySelector('button')?.setAttribute('tabindex', show ? '0' : '-1');
    }
  }

  // Bottle picker: keeps the button price, the sticky bar and any other
  // Add to cart on the page in step with the chosen number of bottles.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'quantity') return;
    const form = input.closest('[data-bottles-form]');
    if (!form) return;

    document.querySelectorAll('[data-bottles-total]').forEach((el) => (el.textContent = input.dataset.total));
    document.querySelectorAll('[data-bottles-summary]').forEach((el) => (el.textContent = input.dataset.summary));
    document.querySelectorAll('[data-bottles-quantity]').forEach((el) => (el.value = input.value));
  });

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  if (!customElements.get('sticky-buy')) customElements.define('sticky-buy', StickyBuy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality"] && !Shopify.designMode) return;
  try {
    
  class QualityBand extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-report-open]');
      if (!this.dialog || !this.opener) return;

      this.opener.addEventListener('click', (event) => {
        event.preventDefault();
        this.dialog.showModal();
      });

      // Close on the X, or on a tap outside the sheet (the backdrop).
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-report-close]')) this.dialog.close();
      });
    }
  }

  if (!customElements.get('quality-band')) customElements.define('quality-band', QualityBand);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-cards"] && !Shopify.designMode) return;
  try {
    
  class ReviewTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-filter]')];
      this.row = this.querySelector('[data-review-row]');
      if (!this.row || this.tabs.length === 0) return;

      this.querySelector('[data-review-tabs]')?.removeAttribute('hidden');
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.show(tab)));
    }

    show(tab) {
      const filter = tab.dataset.filter;
      this.tabs.forEach((t) => t.setAttribute('aria-pressed', String(t === tab)));
      [...this.row.children].forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.type !== filter;
      });
      this.row.scrollTo({ left: 0 });
    }
  }

  if (!customElements.get('review-tabs')) customElements.define('review-tabs', ReviewTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewSlider extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-slider-list]');
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');

      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      this.list.addEventListener('scroll', () => this.update(), { passive: true });
      new ResizeObserver(() => this.update()).observe(this.list);
    }

    // One card (plus the gap) per click.
    go(direction) {
      const card = this.list.querySelector('li');
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      const step = card ? card.offsetWidth + gap : this.list.clientWidth;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.list.scrollBy({ left: direction * step, behavior: smooth ? 'smooth' : 'auto' });
    }

    update() {
      const end = this.list.scrollWidth - this.list.clientWidth - 1;
      this.prev.disabled = this.list.scrollLeft <= 0;
      this.next.disabled = this.list.scrollLeft >= end;
      this.toggleAttribute('data-static', end <= 0);
    }
  }

  if (!customElements.get('review-slider')) customElements.define('review-slider', ReviewSlider);

  } catch(e) { console.error(e); }
})();
})();
